import { BaseError } from "./BaseError";
/**
 * Invalid operation error
 */ export class InvalidOperationError extends BaseError {
    constructor(message){
        super(message);
        this.name = "InvalidOperationError";
    }
}
